import { deflateSync, inflateSync } from 'fflate';

export class UTILS__fflate {
  static compress_string(input: string): string {
    // 1. Convert string to a UTF-8 Uint8Array
    const encoder = new TextEncoder();
    const data = encoder.encode(input);

    // 2. Compress using Deflate (level 9 gives maximum compression)
    const compressed = deflateSync(data, { level: 9 });

    // 3. Convert Uint8Array to Base64 safely across Node and Browser
    let out = btoa(String.fromCharCode(...compressed));

    out = `base64:${out}`;

    return out;
  }

  static decompress_string(base64: string): string {
    if (base64.startsWith('base64:')) base64 = base64.remove_string_protocol();

    let bytes: Uint8Array;

    // 1. Cross-platform Base64 to Uint8Array conversion
    if (typeof Buffer !== 'undefined') {
      // Fast Node.js path
      bytes = Buffer.from(base64, 'base64');
    } else if (typeof (Uint8Array as any).fromBase64 === 'function') {
      // Modern Browser/Runtime path (TC39 Baseline 2024/2025+ feature)
      bytes = (Uint8Array as any).fromBase64(base64);
    } else {
      // Legacy/Fallback Browser path (Highly optimized chunked approach)
      const binary_string = globalThis.atob(base64);
      bytes = new Uint8Array(binary_string.length);
      for (let i = 0; i < binary_string.length; i++) {
        bytes[i] = binary_string.charCodeAt(i);
      }
    }

    // 2. Decompress the data using fflate
    const decompressed = inflateSync(bytes);

    // 3. Decode back to original string (Native across all modern JS environments)
    const decoder = new TextDecoder();

    return decoder.decode(decompressed);
  }
}
